<template>
  <div class="ArtistProfile__badges absolute right-0 bottom-0 flex ml-auto">
    <img
      v-if="artist.photographer"
      src="@/images/icons/photograph-ico.svg"
      class="ArtistProfile__badge-ico"
      title="Photographer"
      v-tippy
    />
    <img
      v-if="artist.collectable"
      src="@/images/icons/collectable-ico.svg"
      class="ArtistProfile__badge-ico"
      title="Collectable Artist"
      v-tippy
    />
    <img
      v-if="artist.established"
      src="@/images/icons/established-ico.svg"
      class="ArtistProfile__badge-ico"
      title="Established Seller"
      v-tippy
    />
    <img
      v-if="artist.rising"
      src="@/images/icons/rising-ico.svg"
      class="ArtistProfile__badge-ico"
      title="Rising Star"
      v-tippy
    />
    <img
      v-if="artist.featured_badge"
      src="@/images/icons/featured-ico.svg"
      class="ArtistProfile__badge-ico"
      title="Featured Artist"
      v-tippy
    />
  </div>
</template>

<script>
export default {
  name: "ArtistProfile.Badges",
  props: {
    artist: {
      required: true,
      type: Object,
    },
  },
}
</script>

<style lang="scss">
.ArtistProfile__badge-ico {
  width: 42px;
  height: 42px;

  &:nth-child(n + 3) {
    display: none;
  }
}

.ArtistProfile__badge-ico + .ArtistProfile__badge-ico {
  @apply ml-4;
}
</style>
